export const RESIZE_PANEL_WIDTH_KEY = 'ITSERIVICE_RESIZE_PANEL_WIDTH_KEY';